import {Component, Input} from '@angular/core';
import {MyModalProvider} from "../../providers/my-modal/my-modal";

/**
 * Generated class for the ModalTypeTagComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'modal-type-tag',
  templateUrl: 'modal-type-tag.html'
})
export class ModalTypeTagComponent {

  @Input('data') data;

  title: string = '选择角色';

  formDirty: boolean = false;

  constructor(private myModal: MyModalProvider) {
    console.log('Hello ModalTypeTagComponent Component');
  }

  confirm(){
    let result = this.data.tags.filter(value => {
      return value.checked;
    });
    this.data.callback(result, this.formDirty);
    this.myModal.dismiss();
  }

  cancel(){
    this.myModal.dismiss();
  }

  isRemovingAll(){
    return this.data.tags.every(value=> !value.checked);
  }

  checkClicked(tag){
    tag.checked =! tag.checked;
    this.formDirty = true;
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-type-tag/modal-type-tag.ts